import clsx from "clsx";
import { Button } from "react-migration/components/Button";
import { logEventV2 } from "react-migration/lib/util/logEventV2";
import { updateExpandedLHS } from "src/js/stores/map/actions/updateExpandedLHS";
import { mapStore } from "src/js/stores/map/store";
import { useSnapshot } from "valtio";
import { updateShowWorkbench } from "src/js/stores/map/actions/updateShowWorkbench";

export const LeftHandSideExpandTrayMobile = ({ className }: { className?: string }) => {
  const { expandedLHS, showWorkbench, settings, selection } = useSnapshot(mapStore);

  if (settings.streetView) return;
  return (
    <Button
      id="expand-lhs-mobile"
      variant="tertiary"
      className={clsx(
        "absolute top-2 left-2 md:hidden",
        "z-10 pointer-events-auto px-3 py-3! bg-background-surface shadow-map-button!",
        className
      )}
      leadIcon="lt-stack-line"
      iconSize="2xl"
      onClick={() => {
        logEventV2({ name: "Explorer expanded", properties: { state: true } });
        // If the LHS is open, but behind the workbench, we want to hide the workbench and show the LHS.
        if (expandedLHS && !!selection && showWorkbench) {
          updateExpandedLHS(true);
          updateShowWorkbench(false);
          // If the LHS is expanded and the selection is not empty but the workbench is hidden, we want to show the workbench.
        } else if (expandedLHS && !!selection && !showWorkbench) {
          updateExpandedLHS(false);
          updateShowWorkbench(true);
          // If the LHS is expanded and the selection is empty, we want to hide the LHS & workbench.
        } else if (expandedLHS && !selection) {
          updateExpandedLHS(false);
          updateShowWorkbench(false);
          // If the LHS is not expanded, we want to expand it and hide the workbench.
        } else if (!expandedLHS) {
          updateExpandedLHS(true);
          updateShowWorkbench(false);
        }
      }}
    />
  );
};
